import { Stack, Typography } from '@mui/material';
import { DegassedJobIcon } from './DegassedJobIcon';
import { useTranslation } from 'react-i18next';
import { RawJobIcon } from './RawJobIcon';

export const MapLegend = () => {
  const [t] = useTranslation('jobs');
  return (
    <Stack
      sx={{
        borderRadius: 2,
        position: 'absolute',
        backgroundColor: 'background.paper',
        bottom: 26,
        left: 16,
      }}
    >
      <Stack
        flexDirection="row"
        gap={3}
        justifyContent="start"
        alignItems="center"
        padding={3.5}
      >
        <DegassedJobIcon />
        <Typography fontWeight={500} noWrap>
          {t('jobOriginTypes.biomass')}
        </Typography>
      </Stack>
      <Stack
        flexDirection="row"
        gap={3}
        justifyContent="start"
        alignItems="center"
        padding={3.5}
      >
        <RawJobIcon />
        <Typography fontWeight={500} noWrap>
          {t('jobOriginTypes.manure')}
        </Typography>
      </Stack>
    </Stack>
  );
};
